import { downloadCall, PostRequest } from "../../../../utils/api";
import { Notification } from "../../../../components/notification/notification";

export const handlePDFDelivery = (item: any, record: any) => {
  if (item?.action === "download") {
    downloadAttachment(record);
  } else {
    generatePDF(record, item?.action);
  }
};

export const handleBulkPDFDelivery = (item: any, records: any[]) => {
  if (records?.length > 0) {
    generateBulkAttachments(item, records);
  }
};

const generateBulkAttachments = async (item: any, records: any[]) => {
  let requestRecords: any[] = [];
  console.log(records);
  records.forEach(record => {
    const payload: any = preparePayload(record, item.displayName);
    requestRecords.push(payload);
  });

  const url = `pdf-generator/attachment/bulk/deliver`;

  const res = await PostRequest(url, JSON.stringify({ records: requestRecords })).catch((error) => {
    Notification(
      "error",
      "Error Generating the PDF. Please try again later."
    );
  });

  if (res) {
    if (res?.data) {
      const responses: [] = res?.data.responses;
      let successfulDeliveredLoanNos: any[] = [];
      responses.forEach((value: any, index) => {
        if (value?.error) {
          Notification("error", value?.error);
        } else {
          successfulDeliveredLoanNos.push(value?.loanNo);
        }
      });
      if (successfulDeliveredLoanNos.length > 0) {
        Notification(
          "success",
          `PDF Generated Successfully to loanNos: ${JSON.stringify(successfulDeliveredLoanNos)}`
        );
      }
    }
  } else {
    Notification(
      "error",
      "Error Generating the PDF. Please try again later."
    );
  }
}

const downloadAttachment = async (record: any) => {
  const url =
    "pdf-generator/attachment/generate-url-info/" +
    record?.deliveryRequestDate.toString().trim() +
    "/" +
    record?.generatedFileName.toString().trim();
  downloadCall("GET", url, record.generatedFileName + ".pdf", null, "blob");
};

const generatePDF = async (record: any, deliveryMode: string) => {

  const payload: any = preparePayload(record, deliveryMode);
  
  const url = `pdf-generator/attachment/deliver`;

  const res = await PostRequest(url, payload).catch((error) => {
    Notification(
      "error",
      "Error Generating the PDF. Please try again later."
    );
  });

  if (res) {
    Notification(
      "success",
      "PDF Generated Successfully. We've delivered it via your selected preference."
    );
  } else {
    Notification(
      "error",
      "Error Generating the PDF. Please try again later."
    );
  }

};

const preparePayload = (record: any, deliveryMode: string): any => {
  const payload: any = {};
  payload.attachmentName = record.attachmentName;
  payload.loanNo = record.loanNo;
  switch (deliveryMode.toLowerCase()) {
    case "all": {
      payload.sendToWhatsapp = true;
      payload.sendToEmail = true;
      break;
    }
    case "email": {
      payload.sendToEmail = true;
      break;
    }
    case "whatsapp": {
      payload.sendToWhatsapp = true;
      break;
    }
  }

  return payload;
}



